var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "new-openai-channel-form" } },
    [
      _c("a-form", [
        _c("div", { staticClass: "form-wrapper" }, [
          _c(
            "div",
            { staticClass: "input-wrapper" },
            [
              _c("label", [
                _vm._v(_vm._s(_vm.$t("whatsappChannel.channelName"))),
              ]),
              _vm._v(" "),
              _c(
                "a-form-item",
                {
                  attrs: {
                    "validate-status": _vm.getErrorStatus("channelName"),
                    help: _vm.getErrorMessage("channelName"),
                  },
                },
                [
                  _c("a-input", {
                    ref: "channelName",
                    attrs: {
                      placeholder: _vm.$t("whatsappChannel.channelName"),
                      name: "channelName",
                    },
                    model: {
                      value: _vm.form.channelName,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "channelName", $$v)
                      },
                      expression: "form.channelName",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "input-wrapper" }, [
            _c("label", [_vm._v("API Anahtarı Modu")]),
            _vm._v(" "),
            _c("div", { staticClass: "key-mode-selector" }, [
              _c(
                "div",
                {
                  staticClass: "key-mode-option",
                  class: { active: _vm.form.keyMode === "byok" },
                  on: {
                    click: function ($event) {
                      _vm.form.keyMode = "byok"
                    },
                  },
                },
                [
                  _c("a-radio", {
                    attrs: { checked: _vm.form.keyMode === "byok" },
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "key-mode-content" }, [
                    _c("div", { staticClass: "key-mode-title" }, [
                      _vm._v("Kendi API Anahtarımı Kullanacağım (BYOK)"),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "key-mode-desc" }, [
                      _vm._v(
                        "OpenRouter hesabınızdaki API anahtarınızı kullanın"
                      ),
                    ]),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "key-mode-option",
                  class: { active: _vm.form.keyMode === "supsis" },
                  on: {
                    click: function ($event) {
                      _vm.form.keyMode = "supsis"
                    },
                  },
                },
                [
                  _c("a-radio", {
                    attrs: { checked: _vm.form.keyMode === "supsis" },
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "key-mode-content" }, [
                    _c("div", { staticClass: "key-mode-title" }, [
                      _vm._v("Supsis AI API Anahtarı Sağlasın"),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "key-mode-desc" }, [
                      _vm._v(
                        "Supsis tarafından sağlanan API anahtarı ile kullanın"
                      ),
                    ]),
                  ]),
                ],
                1
              ),
            ]),
          ]),
          _vm._v(" "),
          _vm.form.keyMode === "byok"
            ? _c(
                "div",
                { staticClass: "input-wrapper" },
                [
                  _c("label", [_vm._v("OpenAI API KEY")]),
                  _vm._v(" "),
                  _c("a-input", {
                    attrs: { placeholder: "OpenAI API KEY", name: "apiKey" },
                    model: {
                      value: _vm.form.apiKey,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "apiKey", $$v)
                      },
                      expression: "form.apiKey",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-footer" }, [
        _c(
          "div",
          { staticClass: "actions" },
          [
            _c("a-button", { on: { click: _vm.handleCancel } }, [
              _vm._v(_vm._s(_vm.$t("message.cancel"))),
            ]),
            _vm._v(" "),
            _c(
              "a-button",
              {
                staticClass: "pr-confirm-btn",
                attrs: { type: "primary", disabled: _vm.loading },
                on: { click: _vm.handleSave },
              },
              [_vm._v("\n                " + _vm._s(_vm.$t("message.save")))]
            ),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }